import React, { useEffect, useState } from "react";
import { PageWrapper } from "components/ui/PageWrapper";

import "styles/main.css";
import { FormInput } from "components/ui/FormInput";
import { TextEditor } from "components/ui/TextEditor";
import { useForm } from "react-hook-form";
import { ButtonLoader } from "components/Loader/ButtonLoader";

import { ComponentLoader } from "components/Loader/ComponentLoader";
import { ErrorComponent } from "components/Alerts/Error";

import {
  CreateResearchDevelopmentBanner,
  GetResearchDevelopmentBanner,
} from "rest/researchDevelopement";

export default function ResearchBannerPage() {
  const {
    register,
    handleSubmit,
    formState: { errors },
    control,
    reset,
  } = useForm();

  const createBanner = CreateResearchDevelopmentBanner();
  const getBanner = GetResearchDevelopmentBanner();
  const [perviewImages, setPreviewImages] = useState("");
  const [defaultImg, setDefaultImg] = useState("");

  const handleChange = (e) => {
    const files = e.target.files[0];
    if (files) {
      const imageUrl = URL.createObjectURL(files);
      setPreviewImages(imageUrl);
    }
  };

  useEffect(() => {
    const defaultValues = {};
    defaultValues.heading = getBanner?.data?.data?.heading;
    defaultValues.sub_heading = getBanner?.data?.data?.sub_heading;
    defaultValues.description = getBanner?.data?.data?.description;
    defaultValues.what_is_heading = getBanner?.data?.data?.what_is_heading;
    defaultValues.what_is_text_1 = getBanner?.data?.data?.what_is_text_1;
    defaultValues.what_is_text_2 = getBanner?.data?.data?.what_is_text_2;
    defaultValues.personnelBanner = getBanner?.data?.data?.image;
    setDefaultImg(getBanner?.data?.data?.image);
    reset(defaultValues);
  }, [getBanner?.data?.data]);

  const onSubmit = (data) => {
    const formData = new FormData();
    formData.append("heading", data?.heading);
    formData.append("sub_heading", data?.sub_heading || "");
    formData.append("description", data?.description);
    formData.append("what_is_heading", data?.what_is_heading || "");
    formData.append("what_is_text_1", data?.what_is_text_1 || "");
    formData.append("what_is_text_2", data?.what_is_text_2 || "");
    formData.append("image", data?.researchBanner[0]);
    createBanner.mutate(formData);
  };

  return (
    <div className="research_page">
      <PageWrapper
        slug="research-banner"
        name="Research And Development Banner"
      />
      <div className="home_banner_input">
        {getBanner?.isError && (
          <ErrorComponent message="OOPS ! something went wrong please try again later" />
        )}
        {getBanner?.isPending ? (
          <ComponentLoader />
        ) : (
          <form onSubmit={handleSubmit(onSubmit)} className="row mt-4 mb-3">
            <div className="mb-3 col-md-6">
              <label htmlFor="researchBanner" className="form-label">
                Research Banner (1540px * 305px)
              </label>
              <FormInput
                type="file"
                name="researchBanner"
                placeholder="researchBanner"
                {...register("researchBanner", {
                  required: !perviewImages && !defaultImg,
                  onChange: (e) => handleChange(e),
                })}
              />
              {errors?.researchBanner && (
                <p className="errorMessage">Field is required</p>
              )}
              {perviewImages && (
                <img
                  src={perviewImages}
                  alt="Research banner Preview"
                  style={{ maxWidth: "300px", marginTop: "10px" }}
                />
              )}
              {!perviewImages && defaultImg && (
                <img
                  src={defaultImg}
                  alt="Research banner Preview"
                  style={{ maxWidth: "300px", marginTop: "10px" }}
                />
              )}
            </div>
            <div className="mb-3 col-md-6">
              <label htmlFor="mainHeading" className="form-label">
                Main Heading
              </label>
              <FormInput
                type="text"
                name="heading"
                placeholder="heading"
                {...register("heading", { required: true })}
              />
              {errors?.heading && (
                <p className="errorMessage">Heading is required</p>
              )}
            </div>
            <div className="mb-3 col-md-6">
              <label htmlFor="sub_heading" className="form-label">
                Sub Heading
              </label>
              <FormInput
                type="text"
                name="sub_heading"
                placeholder="sub heading"
                {...register("sub_heading")}
              />
            </div>
            <div className="mb-3 col-md-12">
              <label htmlFor="description" className="form-label">
                Description
              </label>
              <TextEditor
                control={control}
                placeholder="Description"
                defaultValue={getBanner?.data?.data?.description}
                {...register("description", { required: true })}
              />
              {errors?.description && (
                <p className="errorMessage">Description is required</p>
              )}
            </div>

            <div className="col-12">
              <hr className="my-4" />
              <h5 className="fw-bold mb-3">
                "What is Custom Lipid Synthesis?" Section
              </h5>
            </div>

            <div className="mb-3 col-md-12">
              <label htmlFor="what_is_heading" className="form-label">
                Heading
              </label>
              <FormInput
                type="text"
                name="what_is_heading"
                placeholder="What is Custom Lipid Synthesis?"
                {...register("what_is_heading")}
              />
            </div>
            <div className="mb-3 col-md-6">
              <label htmlFor="what_is_text_1" className="form-label">
                Paragraph 1
              </label>
              <TextEditor
                control={control}
                name="what_is_text_1"
                placeholder="First paragraph"
                defaultValue={getBanner?.data?.data?.what_is_text_1}
                {...register("what_is_text_1")}
              />
            </div>
            <div className="mb-3 col-md-6">
              <label htmlFor="what_is_text_2" className="form-label">
                Paragraph 2
              </label>
              <TextEditor
                control={control}
                name="what_is_text_2"
                placeholder="Second paragraph"
                defaultValue={getBanner?.data?.data?.what_is_text_2}
                {...register("what_is_text_2")}
              />
            </div>

            {createBanner?.isPending ? (
              <div>
                <ButtonLoader />
              </div>
            ) : (
              <div className="mb-3 col-12">
                <input type="submit" value="submit" className="input_submit" />
              </div>
            )}
          </form>
        )}
      </div>
    </div>
  );
}
